import { useEffect } from "react";

const IconInit: React.FC = () => {
  useEffect(() => {
    const head = document.head;

    const weights: Array<
      "regular" | "thin" | "light" | "bold" | "fill" | "duotone"
    > = ["regular", "thin", "light", "bold", "fill", "duotone"];

    for (const weight of weights) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.type = "text/css";
      link.href = `https://unpkg.com/@phosphor-icons/web@2.1.1/src/${weight}/style.css`;
      head.appendChild(link);
    }
  }, []);

  return null;
};

export default IconInit;
